// extracted by mini-css-extract-plugin
export default {"page":"RegistrationPage_page__wCeDF","inputBlock":"RegistrationPage_inputBlock__G-tns","inputLegend":"RegistrationPage_inputLegend__4gTrS"};